import { render } from "./SectionComponent.vue?vue&type=template&id=2ec13618&scoped=true"
import script from "./SectionComponent.vue?vue&type=script&lang=js"
export * from "./SectionComponent.vue?vue&type=script&lang=js"

import "./SectionComponent.vue?vue&type=style&index=0&id=2ec13618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec13618"]])

export default __exports__